import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtDate } from "../SuperHeader";
import { useAdminFetch, TabState } from "../useAdminFetch";
import { useDebounced } from "./ContactsTab";
import Pager from "../Pager";

const STATUSES = ["new", "contacted", "interested", "qualified", "follow_up", "site_visit", "negotiation", "won", "lost"];
const SCORES = ["HOT", "HIGH", "MEDIUM", "LOW"];

export default function LeadsTab({ cid }) {
  const [f, setF] = useState({ q: "", status: "all", score: "all", source: "all" });
  const [page, setPage] = useState(1);
  const dq = useDebounced(f.q);
  useEffect(() => setPage(1), [dq, f.status, f.score, f.source]);
  const params = { q: dq || undefined, page, ...Object.fromEntries(["status", "score", "source"].filter((k) => f[k] !== "all").map((k) => [k, f[k]])) };
  const { data, error, loading } = useAdminFetch(`/admin/companies/${cid}/leads`, params);
  const sel = (k, opts, label) => (
    <Select value={f[k]} onValueChange={(v) => setF({ ...f, [k]: v })}>
      <SelectTrigger className="w-40" data-testid={`leads-filter-${k}`}><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white"><SelectItem value="all">{label}</SelectItem>{opts.map((o) => <SelectItem key={o} value={o}>{o.replace("_", " ")}</SelectItem>)}</SelectContent>
    </Select>
  );
  return (
    <Card className="p-4 border-slate-200 space-y-3" data-testid="leads-tab">
      <div className="flex flex-wrap gap-2">
        <Input placeholder="Search name or phone" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} className="w-60" data-testid="leads-search" />
        {sel("status", STATUSES, "All statuses")}{sel("score", SCORES, "All scores")}{sel("source", data?.sources || [], "All sources")}
      </div>
      <TabState loading={loading && !data} error={error} empty={data?.items.length === 0} emptyText="No leads found." testid="leads">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600"><tr><th className="p-2 text-left">Lead</th><th className="p-2 text-left">Source</th><th className="p-2 text-left">Status</th><th className="p-2 text-left">Score</th><th className="p-2 text-left">Assigned</th><th className="p-2 text-left">Created</th></tr></thead>
            <tbody>{(data?.items || []).map((l) => (
              <tr key={l.id} className="border-t border-slate-100" data-testid={`lead-row-${l.id}`}>
                <td className="p-2">{l.name || "—"}<div className="text-[11px] font-mono text-slate-500">{l.phone}</div></td>
                <td className="p-2 text-xs">{l.source || "—"}</td>
                <td className="p-2 capitalize text-xs">{(l.status || "").replace("_", " ")}</td>
                <td className="p-2"><Badge variant="outline">{l.score}</Badge></td>
                <td className="p-2 text-xs">{l.assigned_name}</td>
                <td className="p-2 text-xs text-slate-500">{fmtDate(l.created_at)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      </TabState>
      {data && data.total > 0 && <Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} testid="leads-pager" />}
    </Card>
  );
}
